/* import __COLOCATED_TEMPLATE__ from './filter-collection.hbs.js'; */
var _dec, _class;
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import { get, computed } from '@ember/object';
import Component from '@ember/component';
import { A } from '@ember/array';
import { isBlank, isEmpty } from '@ember/utils';
import { assert } from '@ember/debug';
import { escapeRegExp } from '@square/dashboard-utilities/utils/string';

/**
## Overview

Helper component that allows filtering a collection for items that match a string. Yields `filteredCollection`,
a subset of the collection, where each item has one or more `filterProperties` that match `query`. Only one of
`filterProperty` (String) or `filterProperties` (Array) should be specified.

```example
@title Basic Usage

@controller-properties
{
  collection: [
    {
      name: 'T-Shirt'
    },
    {
      name: 'Hat'
    }
  ]
}

@hbs
{{#filter-collection collection=collection
                     query=query
                     filterProperty="name" as |filteredCollection|}}
  <Input @value={{inputValue}} {{on "change" (action (mut query) inputValue)}} />
  {{#each filteredCollection as |item|}}
    <div>{{item.name}}</div>
  {{/each}}
{{/filter-collection}}
```

@param {Array} [collection] - Collection of items to filter
@param {String} [filterProperty] - the property on each item to test against the query (superceded by filterProperties)
@param {Array} [filterProperties] - list of several properties on each item to test against the query (supercedes filterProperty)

**/
let FilterCollection = (_dec = computed('query', 'collection.[]', 'filterProperties.[]'), (_class = class FilterCollection extends Component {
  didReceiveAttrs() {
    super.didReceiveAttrs();
    if (this.filterProperty) {
      this.set('filterProperties', [this.filterProperty]);
    }
    assert('filter-collection: must specify filterProperty or non-empty filterProperties', !isEmpty(this.filterProperties));
  }
  get matchingCollection() {
    const query = this.query;
    if (isBlank(query)) {
      return A(this.collection);
    } else {
      const queryRegExp = new RegExp(escapeRegExp(query), 'gi');
      const matchingCollection = this.collection.filter(option => {
        return this.filterProperties.map(property => get(option, property) === undefined ? '' : get(option, property)).some(value => value.match(queryRegExp));
      });
      return A(matchingCollection);
    }
  }
}, (_applyDecoratedDescriptor(_class.prototype, "matchingCollection", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "matchingCollection"), _class.prototype)), _class));
export { FilterCollection as default };